import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { MapaMarkerService } from './.././../../../monitoreo/services/mapa-marker.service';
import { MapaConsolaService } from '../../../services/mapa-consola.service';
import StreetViewService = google.maps.StreetViewService;
import StreetViewPanorama = google.maps.StreetViewPanorama;
import StreetViewPanoramaData = google.maps.StreetViewPanoramaData;
import StreetViewStatus = google.maps.StreetViewStatus;

@Component({
	selector: 'kt-mapa-modal',
	templateUrl: './mapa-modal.component.html',
	styleUrls: ['./mapa-modal.component.scss']
})
export class MapaModalComponent implements OnInit {
	public panorama: StreetViewPanorama;
	public sv: StreetViewService;
	public isStreetView: boolean = true;
	public isAvailable: boolean = true;

	constructor(private dialogRef: MatDialogRef<MapaModalComponent>, private mapaConsolaService: MapaConsolaService,
		private mapaMarkerService: MapaMarkerService,
		@Inject(MAT_DIALOG_DATA) public data) { }

	ngOnInit() {
		//this.mapaMarkerService.inicializarMapa();
		//this.mapaMarkerService.pintarMarcadores(this.data);
		this.mapaConsolaService.inicializarMapa();
		this.mapaConsolaService.pintarMarcadores(this.data);

	}


	verStreetView() {
		const { lat, lng } = this.data;
		const coordinates = { lat, lng };
		this.sv = new StreetViewService();
		this.panorama = new StreetViewPanorama(document.getElementById('pano'));

		this.sv.getPanorama({
			location: coordinates,
			radius: 50
		}, (data, status) => {
			this.processSVData(data, status);
			this.panorama.setVisible(true);
			this.isStreetView = false;
		}
		);
	}

	public processSVData(data: StreetViewPanoramaData, status: StreetViewStatus): void {
		if (data != null) {
			this.panorama.setPano(data.location.pano);
			this.panorama.setPov({
				heading: 270,
				pitch: 0
			});
		} else {
			this.isAvailable = false;
		}
	}


	public minimizarPopup() {
		this.dialogRef.addPanelClass('displayNone');
	}

	public maximizarPopup() {
		this.dialogRef.removePanelClass('displayNone');
	}

	public cerrarPopup() {
		this.dialogRef.close();
	}


}
